import { FeatureField } from './scad-feature-types';

export function parseScadArgs(argsStr: string, fields: FeatureField[]): Record<string, any> {
  if (!argsStr) return {};

  let depth = 0;
  let currentArg = '';
  const args: string[] = [];
  
  for (let i = 0; i < argsStr.length; i++) {
    const char = argsStr[i];
    if (char === '[') depth++;
    else if (char === ']') depth--;

    if (char === ',' && depth === 0) {
      args.push(currentArg.trim());
      currentArg = '';
    } else {
      currentArg += char;
    }
  }
  if (currentArg.trim()) args.push(currentArg.trim());

  const values: Record<string, any> = {};
  let positionalIndex = 0;

  for (const arg of args) {
    if (arg.includes('=')) {
      const [key, val] = arg.split('=').map((s) => s.trim());
      const field = fields.find((f) => f.name === key);
      if (field) {
        values[key] = parseValue(val, field.type);
      }
    } else {
      // Positional
      if (positionalIndex < fields.length) {
        const field = fields[positionalIndex];
        values[field.name] = parseValue(arg, field.type);
        positionalIndex++;
      }
    }
  }
  return values;
}

function parseValue(valStr: string, type: string): any {
  if (type === 'number') return parseFloat(valStr);
  if (type === 'boolean') return valStr === 'true';
  if (type === 'string') return valStr.replace(/^["']|["']$/g, '');
  if (type.startsWith('vector')) {
    const cleaned = valStr.replace(/^\[|\]$/g, '');
    return cleaned.split(',').map((s) => parseFloat(s.trim()));
  }
  return valStr;
}

export function findFeatureInvocationFull(
  text: string,
  offset: number,
  featureId: string,
): { argsStr: string; startOffset: number; endOffset: number } | null {
  if (text.substring(offset, offset + featureId.length) !== featureId)
    return null;

  let argsStr = '';
  let foundOpen = false;
  let depth = 0;
  let closeOffset = -1;

  for (let i = offset + featureId.length; i < text.length; i++) {
    const char = text[i];
    if (!foundOpen) {
      if (char === '(') {
        foundOpen = true;
        depth = 1;
      } else if (!/\s/.test(char)) {
        return null;
      }
    } else {
      if (char === '(') depth++;
      else if (char === ')') {
        depth--;
        if (depth === 0) {
          closeOffset = i;
          break;
        }
      }
      if (depth > 0) {
        argsStr += char;
      }
    }
  }

  if (closeOffset === -1) return null;

  let endOffset = closeOffset + 1;
  // absorb trailing semicolon if it exists
  if (endOffset < text.length && text[endOffset] === ';') {
    endOffset++;
  }

  return {
    argsStr,
    startOffset: offset,
    endOffset,
  };
}
